import React, { useEffect } from 'react'
import { Checkbox, Table } from 'semantic-ui-react'
// import Axios from 'axios'
// import { HttpClient } from '../../../commonApis/httpClient'
import EmergencyShipment from './EmergencyShipment'
const EmergencyProcedureShipmentList = (props) => {
    const { 
        translate,
        shipmentData, 
        setShipmentData, 
        isLoading, 
        setLoader, 
        onMarkShipment, 
        getAllShipment, 
        updateCustomState,
        setError,
        customStateMapper
    } = props
    
    useEffect(() => {
        getAllShipment()
        return () => {
            setShipmentData({ shipmentList: [], selectAll: false })
            setLoader('initial')
            setError(null)
        }
    }, [])

    return (
        <div className='container__table'>
            {(isLoading !== 'loading'
                && !shipmentData?.shipmentList?.length) && (
                    <div style={{ color: 'red', textAlign: 'center', fontWeight: '600' }}>
                        NO DATA FOUND
                    </div>
                )}
            {!!shipmentData?.shipmentList?.length && (
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell style={{ width: '20px', paddingLeft: '24px' }}>
                                <Checkbox
                                    label={'_'}
                                    checked={shipmentData?.selectAll}
                                    onChange={(e, data) => {
                                        setShipmentData((prevShipmentData) => ({
                                            ...prevShipmentData,
                                            selectAll: data?.checked,
                                            shipmentList: prevShipmentData?.shipmentList?.map(
                                                (item) => ({ ...item, isChecked: data?.checked })
                                            )
                                        }))
                                    }}
                                />
                            </Table.HeaderCell>
                            <Table.HeaderCell>SHIPMENT ID</Table.HeaderCell>
                            <Table.HeaderCell>MRN</Table.HeaderCell>
                            <Table.HeaderCell>ACCEPTANCE DATE</Table.HeaderCell>
                            <Table.HeaderCell>STATUS</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {shipmentData?.shipmentList?.map((item) => {
                            return <EmergencyShipment
                                key={item?.shipmentId}
                                dataSource={item}
                                onMarkShipment={onMarkShipment}
                                updateCustomState={updateCustomState}
                                translate={translate}
                                customStateMapper={customStateMapper}
                            />
                        })}
                    </Table.Body>
                </Table>
            )}
        </div>
    )
}

export default EmergencyProcedureShipmentList



const getData = () => ([
    {
        "shipmentId": "KX-I5H7-20310",
        "mrn": "65464564",
        "acceptanceDate": "1702394393893",
        "customsState": "STATE_NOOD_FILED_DECL_NOT_SENT"
    },
    {
        "shipmentId": "KX-I5H7-20583",
        "mrn": "897878787",
        "acceptanceDate": "1702547227687",
        "customsState": "STATE_NOOD_FILED_DECL_NOT_SENT"
    },
    {
        "shipmentId": "KX-I5H7-20850",
        "mrn": "34543454",
        "acceptanceDate": "1702981749846",
        "customsState": "STATE_NOOD_FILED_DECL_NOT_SENT"
    },
    {
        "shipmentId": "KX-I5H7-20851",
        "mrn": "6576765756",
        "acceptanceDate": "1702981796663",
        "customsState": "STATE_NOOD_FILED_DECL_NOT_SENT"
    },
    {
        "shipmentId": "KX-I5H7-20905",
        "mrn": "45654657",
        "acceptanceDate": "1700118159531",
        "customsState": "STATE_NOOD_FILED_DECL_NOT_SENT"
    },
    {
        "shipmentId": "KX-Y2D9-135",
        "mrn": "332432432432",
        "acceptanceDate": "1700243610289",
        "customsState": "STATE_NOOD_FILED_DECL_NOT_SENT"
    },
    {
        "shipmentId": "KX-I5H7-21453",
        "mrn": "234324324",
        "acceptanceDate": "1700039757855",
        "customsState": "STATE_NOOD_FILED_DECL_NOT_SENT"
    },
    {
        "shipmentId": "KX-I5H7-21613",
        "mrn": "6456456456",
        "acceptanceDate": "1700236197802",
        "customsState": "STATE_NOOD_FILED_DECL_NOT_SENT"
    },
    {
        "shipmentId": "KX-I5H7-21906",
        "mrn": "56564645645",
        "acceptanceDate": "1701408716795",
        "customsState": "STATE_NOOD_FILED_DECL_NOT_SENT"
    }
])